import Spinner from "../../common/components/Spinner";
import I18n from "i18n-js";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TrackdechetsErrorWithTooltip } from "./TrackdechetsErrorWithTooltip";
import { BadgeWithTooltip } from "../../common/components/elements/BadgeWithTooltip";

TrackdechetsErrorCell.propTypes = {
  message: PropTypes.string,
  loading: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date),
  error: PropTypes.bool,
  syncStatus: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
  showSyncStatus: PropTypes.bool,
  refresh: PropTypes.func.isRequired,
};

export function TrackdechetsErrorCell({
  message = null,
  createdAt = Date.now(),
  error = false,
  loading = false,
  syncStatus = null,
  showSyncStatus = false,
  refresh,
}) {
  const [errorMessages, setErrorMessages] = useState([]);

  useEffect(() => {
    if (!message) {
      setErrorMessages([]);
      return;
    }
    setErrorMessages(JSON.parse(message));
  }, [message]);

  if (loading) {
    return <Spinner />;
  }

  const hasTrackdechetsError = errorMessages.length > 0;
  const hasSyncStatus = showSyncStatus && [true, false, null].includes(syncStatus);

  if (!hasTrackdechetsError && !hasSyncStatus) {
    return null;
  }

  const shouldShowRefresh = hasTrackdechetsError || syncStatus === false;
  const syncStatusClassName = `trackdechets-sync-status intervention-trackdechets-sync-status${
    shouldShowRefresh ? " with-refresh" : ""
  }`;

  if (error) {
    return (
      <div className={syncStatusClassName}>
        <BadgeWithTooltip
          type="danger"
          tooltipTitle={I18n.t(
            "trackdechets.sync_statuses_table.cell.badges.error.title",
          )}
          badgeLabel={I18n.t(
            "trackdechets.sync_statuses_table.cell.badges.error.value",
          )}
        />
      </div>
    );
  }

  if (hasSyncStatus && !hasTrackdechetsError) {
    const type = syncStatus === null ? "secondary" : syncStatus ? "primary" : "warning";
    const statusKey =
      syncStatus === null ? "intervention_not_concerned" : syncStatus ? "intervention_ok" : "intervention_no";
    const badgeLabel = I18n.t(
      `trackdechets.sync_statuses_table.cell.badges.${statusKey}.value`,
    );
    const tooltipTitle = I18n.t(
      `trackdechets.sync_statuses_table.cell.badges.${statusKey}.title`,
    );

    const badge = (
      <BadgeWithTooltip
        type={type}
        tooltipTitle={tooltipTitle}
        badgeLabel={badgeLabel}
      />
    );

    return (
      <div className={syncStatusClassName}>
        {badge}
        {shouldShowRefresh && (
          <button className="btn btn-xs refresh" title="Rafraîchir" onClick={refresh}>
            <i className="fa-solid fa-refresh" />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`${syncStatusClassName} trackdechets-error`}>
      <TrackdechetsErrorWithTooltip
        tooltipTitle={"Trackdechets Error"}
        badgeLabel={"ERROR"}
        lastUpdatedAt={createdAt}
        errors={errorMessages}
      />
      {shouldShowRefresh && (
        <button className="btn btn-xs refresh" title="Rafraîchir" onClick={refresh}>
          <i className="fa-solid fa-refresh" />
        </button>
      )}
    </div>
  );
}
